import { Box, Button, HStack, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { MembershipFilterSummary } from "../../components/MemberFilterQueryModal/MemberFilterSummary";
import { FilterMode } from "./types";

interface ManualFiltersSectionProps {
  filterMode: FilterMode;
  filterQuery: string;
  onOpenModal: () => void;
  onClearFilters: () => void;
  onQueryChange: (queryString: string) => void;
}

export const ManualFiltersSection: React.FC<ManualFiltersSectionProps> = ({
  filterMode,
  filterQuery,
  onOpenModal,
  onClearFilters,
  onQueryChange,
}) => {
  const isActive = filterMode === "manualFilter" && !!filterQuery;

  return (
    <VStack w="100%" alignItems="flex-start" spacing={2} pb={2}>
      <Text fontSize="sm" fontWeight="bold">
        Manual Filters
      </Text>
      <Text fontSize="sm" color="gray.700">
        Quickly apply filters to target members for this notification. These
        filters are not saved for reuse.
      </Text>
      {isActive && (
        <Box pl={2}>
          <MembershipFilterSummary
            queryString={filterQuery}
            variant="compact"
            onQueryChange={onQueryChange}
          />
        </Box>
      )}
      <HStack spacing={2}>
        <Button variant="cherry-outline" onClick={onOpenModal}>
          {isActive ? "Edit Filters" : "Select Filters"}
        </Button>
        {isActive && (
          <Button variant="cherry-outline-inverse" onClick={onClearFilters}>
            Clear Filters
          </Button>
        )}
      </HStack>
    </VStack>
  );
};
